import React from 'react';
import { Switch } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import s from './ModeSwitch.module.sass';

const ModeSwitch = ({ Auth0 }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!Auth0.hasScopes(['deliveries:send-to-customer', 'deliveries:receive-from-customer'])) {
    return null;
  }
  
  const isPublic = !location.pathname.includes('admin') && 
    Auth0.hasScopes(['deliveries:send-to-customer', 'deliveries:receive-from-customer']);

  const handleSwitchMode = () => {
    if (isPublic) {
      navigate('/admin');
    } else {
      navigate('/');
    }
  };
  
  return (
    <div className={s['switch-wrapper']}>
      Publikt läge <Switch onClick={handleSwitchMode} checked={isPublic} />
    </div>
  );
};

export default ModeSwitch;